<template>
  <div class="w-100 mb-4">
    <div class="card mb-4">
      <div class="card-header pb-0">
        <h6 class="text-uppercase">Notificaciones</h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="notificationMessage" class="font-weight-bold">
                Contenido del mensaje de notificación
              </label>
              <textarea
                id="notificationMessage"
                class="form-control"
                v-model="messageContent"
                rows="6"
                placeholder="Ingrese el mensaje que se enviará como notificación..."
              ></textarea>
              <small class="text-muted">
                Este mensaje será enviado a todos los usuarios que tienen
                habilitado: "Mostrar notificacion de bloqueo".
              </small>
            </div>

            <div v-if="error" class="alert alert-danger mt-3" role="alert">
              {{ error }}
            </div>

            <div class="d-flex justify-content-end mt-3">
              <button
                class="btn btn-secondary mr-2"
                @click="loadNotification"
                :disabled="loading"
              >
                <i class="fas fa-sync-alt"></i> Recargar
              </button>
              <button
                class="btn btn-primary"
                @click="saveNotification"
                :disabled="loading"
              >
                <span v-if="loading">
                  <i class="fas fa-spinner fa-spin"></i> Guardando...
                </span>
                <span v-else>
                  <i class="fas fa-save"></i> Guardar notificación
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/utils/httpRequest";

export default {
  name: "Notifications",
  data() {
    return {
      messageContent: "",
      loading: false,
      error: null,
    };
  },
  mounted() {
    this.loadNotification();
  },
  methods: {
    async loadNotification() {
      this.loading = true;
      this.error = null;
      try {
        const { data } = await get("notifications/current");
        if (data && data.message) {
          this.messageContent = data.message;
        }
      } catch (error) {
        console.error("Error loading notification:", error);
        this.error = "Error al cargar la notificación actual";
      } finally {
        this.loading = false;
      }
    },

    async saveNotification() {
      this.error = null;

      // Validation: message cannot be empty
      if (!this.messageContent || this.messageContent.trim() === "") {
        this.error = "El contenido del mensaje no puede estar vacío";
        return;
      }

      this.loading = true;
      try {
        await post("notifications", {
          message: this.messageContent.trim(),
        });

        this.$swal({
          html: "Notificación guardada exitosamente",
          icon: "success",
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error saving notification:", error);
        this.error =
          "Error al guardar la notificación: " +
          (error.message || "Error desconocido");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.alert {
  margin-bottom: 0;
}
</style>
